module.exports = __webpack_public_path__ + "img/avatar3.804ee5ef.png";